<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-clock"></i> {{ _('Scheduled task') }} {{ task.id }}</h3>
          <span class="subtitle">{{ $filters.timestampToDate(task.ts) }} {{ _('at') }} {{ $filters.timestampToTime(task.ts) }}</span>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <div class="row" v-if="task">
        <div class="col-md-12">
          <hr/>
          <h3>{{ _('General') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 leftcol">
          <div class="form-group">
            <label for="type">{{ _('Type') }}</label>
            <p>{{ getTaskTypeName(task.type) }}</p>
          </div>
          <div class="form-group">
            <label for="type">{{ _('Status') }}</label>
            <p>{{ getTaskStatusTitle(task.status) }}</p>
          </div>
          <div class="form-group">
            <label for="type">{{ _('Attempts') }}</label>
            <p>{{ task.tries }}</p>
          </div>
        </div>
        <div class="col-sm-6 rightcol">
          <template v-if="data">
            <div class="form-group" v-if="action">
              <label for="message">{{ _('Action') }}</label><br />
              <p>{{ getTaskActionTitle(action) }}<template v-if="action === 'visibility' && data.enableCatalog !== '0'"> - {{ getEnabledVersions(data.enableCatalog) }}</template></p>
            </div>
            <div class="form-group" v-if="data.targetIds">
              <label for="message">{{ _('Targets') }}</label><br />
              <p><span v-for="id in data.targetIds">{{ _('Product') }} {{ id }} </span></p>
            </div>
            <div class="form-group" v-if="false">
              <label for="message">{{ _('Raw data') }}</label><br />
              <div class="well">
                <code v-if="task.data">{{ JSON.parse(task.data) }}</code>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="flex-row space-between">
        <button class="btn btn-danger" v-on:click="remove"><i class="fa fa-fw fa-trash"></i> {{ _('Delete') }}</button>
        <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'

export default {
  data () {
    const _ = useNuxtApp().$translate
    let taskTypes = [
      { 'id': '', 'name': _('All') },
      { 'id': 'productAction', 'name': _('Product') },
      { 'id': 'report', 'name': _('Report') },
      { 'id': 'temperature', 'name': _('Temperature') },
      { 'id': 'lock', 'name': _('Lock') },
    ]
    return {
      taskTypes: taskTypes,
      task: {}
    }
  },
  mixins: [components],
  computed: {
    action () {
      if (!this.task || !this.task.data) {
        return null
      }
      const data = JSON.parse(this.task.data)
      if (data) {
        return data.action
      }
      return null
    },
    data () {
      if (!this.task || !this.task.data) {
        return null
      }
      const data = JSON.parse(this.task.data)
      if (data) {
        return data.data
      }
      return null
    }
  },
  methods: {
    getEnabledVersions (enableCatalog) {
      if (enableCatalog === '0') {
        return ''
      }
      return enableCatalog.split(';').map(v => this.getVersionName(v)).join(', ')
    },
    getTaskTypeName (type) {
      const task = this.taskTypes.find(t => t.id === type)
      if (task) {
        return task.name
      }
      return type
    },
    getTaskStatusTitle (val) {
      switch (parseInt(val)) {
        case 0:
          return this._('Scheduled')
        case 1:
          return this._('Done')
        case 2:
          return this._('Failed')
        default:
          return this._('Processing')
      }
    },
    getTaskActionTitle (val) {
      switch (val) {
        case 'publish':
          return this._('Publish')
        case 'archive':
          return this._('verb|Archive')
        case 'visibility':
          return this._('Change Storefront visibility')
        default:
          return this._(val)
      }
    },
    loadScheduledTask (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/scheduledtasks/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject(e)
          return
        }
        this.loading = false
        this.task = response.data
        resolve(response.data)
      })
    },
    close () {
      if (this.component && this.component.initData && this.component && this.component.initData.modal) {
        this.$emit('close')
      } else {
        this.EventBus.$emit('hideDetailsColumn', {
          shopId: this.shopId,
          data: {
            trail: this.componentTrail
          }
        })
      }
    },
    remove () {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          await axios.delete(this.baseDomain + this.shopId + '/scheduledtasks/' + this.task.id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject(e)
          return
        }
        this.loading = false
        this.close()
        resolve()
      })
    }
  },
  created () {
    if (this.component && this.component.initData) {
      try {
        this.loadScheduledTask(this.component.initData.scheduledTaskId)
      } catch(e) {}
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.task && this.task.id && parseInt(this.task.id, 10) !== parseInt(this.component.initData.scheduledTaskId, 10)) {
        try {
          await this.loadScheduledTask(this.component.initData.scheduledTaskId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['scheduledTaskUpdate'] = async (message) => {
        if (message && message.data && this.task && parseInt(message.data.id, 10) === parseInt(this.task.id, 10)) {
          try {
            await this.loadScheduledTask(message.data.id)
          } catch(e) {}
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }  
}
</script>